import envConfig from '@hulu/env-config';
import { Auth } from 'aws-amplify';
import axios from 'axios';

const baseService = axios.create({
  baseURL: envConfig.REACT_APP_AD_MANAGER_API,
});

baseService.interceptors.request.use(async (config) => {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();

  config.headers.Authorization = `Bearer ${idToken}`;

  return config;
});

export { baseService };
